<template>
  <div v-if="!title">YOU NEED TO SPECIFY A 'title' prop</div>
  <div v-else-if="!events[title]">'{{ title }}' not found in events.json</div>
  <table v-else>
    <colgroup>
      <col class="leftColumn" span="1" />
      <col class="middleColumn" span="1" />
      <col class="middleColumn" span="1" />
      <col />
      <!-- The fourth column will fill the remaining space -->
    </colgroup>
    <tfoot>
      <tr>
        <td colspan="4">
          <ol>
            <li v-for="(subtitle, idx) in subtitles" :key="`${idx}-footnote`">
              Registration for {{ subtitle.toLowerCase() }} participation
              <span v-if="item[subtitle]['lateRegistration']">
                increases by ${{ item[subtitle]["lateRegistration"]["fee"] }} after
                <span
                  v-if="item[subtitle]['lateRegistrationOld']"
                  style="text-decoration: line-through">
                  {{ nbsp(item[subtitle]["lateRegistrationOld"]) }}
                </span>
                {{ nbsp(item[subtitle]["lateRegistration"]["begins"]) }}, then
              </span>
              closes {{ nbsp(item[subtitle]["registrationCloses"]) }}.
            </li>
          </ol>
        </td>
      </tr>
    </tfoot>
    <tbody>
      <tr>
        <th class="alignLeft">{{ abbreviate(title) }}</th>
        <th v-for="(subtitle, index) in subtitles" :key="index">
          {{ abbreviate(subtitle) }}<sup>{{ index + 1 }}</sup>
        </th>
        <th />
      </tr>
      <tr v-for="(category, index) of categories" :key="`${fee}-${index}`">
        <td class="alignLeft">{{ category }}:</td>
        <td v-for="(subtitle, idx) in subtitles" :key="`${idx}-${subtitle}`">
          ${{ item[subtitle]["fees"][category] }}
        </td>
        <td />
      </tr>
    </tbody>
  </table>
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
const props = defineProps(["title"]);
import events from "@/assets/years/2024/Registration/events.json";
const item = events[props.title];
const subtitles = Object.keys(item);
log(`subtitles = ${subtitles}`);
log(`subtitles[0] = ${subtitles[0]}`);
log(`item[subtitles[0]] = ${JSON.stringify(item[subtitles[0]])}`);
const fees = item[subtitles[0]]["fees"];
log(`fees = ${JSON.stringify(fees)}`);
const categories = Object.keys(fees);
log(`categories = ${JSON.stringify(categories)}`);
// const footnoteSymbol = ["*", "†"];
// abbreviate()
import {inject} from "vue";
const displayWidth = inject("displayWidth");
function abbreviate(heading) {
  log(`displayWidth = ${displayWidth.value}`);
  if (displayWidth.value !== "narrow") return heading;
  heading = heading.replace(/\s+participation/i, "");
  heading = heading.replace(/VIZBI\s*/i, "");
  return heading;
}
// nbsp()
function nbsp(text) {
  return text.replace(/ /g, "\u00A0");
}
</script>

<style scoped>
table {
  table-layout: fixed;
  border-collapse: collapse;
  margin-bottom: 0.3em;
  width: 100%;
  text-align: center;
  background: var(--background-color);
}
th {
  padding-right: 12px;
  color: #999;
  font-size: 100%;
  font-weight: 900;
  letter-spacing: 0.2em;
  text-transform: uppercase;
}
.leftColumn {
  width: 240px;
}
.middleColumn {
  width: 120px;
}
.narrow .leftColumn {
  width: 9rem;
}
.narrow .middleColumn {
  width: 7rem;
}
.narrow th {
  font-size: 85%;
}
td,
th {
  padding: 6px;
}
tr {
  vertical-align: top;
}
.alignLeft {
  text-align: left;
}
tr:nth-child(even) {
  background: var(--background-color-subtle);
}
tfoot td {
  padding-top: 0.05rem;
  font-style: italic;
  background: var(--background-color);
}

ol {
  padding-left: 0; /* Remove default padding */
  text-align: left;
  counter-reset: item; /* Initialize the counter */
}
ol li {
  list-style: none; /* Remove default list styling */
  position: relative; /* Needed for absolute positioning of pseudo-elements */
  margin-left: 0px; /* Adjust as needed to align with your text */
  padding-left: 10px; /* Space for the number */
  margin-bottom: 0.25rem;
  font-size: 90%;
}
ol li::before {
  content: counter(item) "."; /* Add a period after the number */
  counter-increment: item; /* Increment the counter */
  position: absolute;
  left: 0; /* Align numbers to the left edge */
  top: 0; /* Position at the top for superscript effect */
  font-size: smaller; /* Smaller font size for superscript effect */
  vertical-align: super; /* Superscript alignment */
}
</style>
